<template>
    <div>
        <loading :active.sync="loader.isLoading" :can-cancel="loader.canCancel" :is-full-page="loader.fullPage" :color="loader.color" :height="loader.height" :width="loader.width" :background-color="loader.backgroundColor" :loader="loader.loader"></loading>
        <div class="row" style="margin-top: 100px">
          <div class="col-md-3">
              <div class="card report-card">
                  <div class="card-body">
                  <div class="float-right">
                      <i class="dripicons-user-group report-main-icon"></i>
                  </div>
                  <h5><span class="badge badge-success">Total Produksi Fiber</span></h5>
                  <h3 class="my-3">
                      <span v-if="loadingSales === false">
                      <div class="loadingio-spinner-bars-km984sg9h2">
                          <div class="ldio-m41ff6uvz8">
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                          </div>
                      </div>
                      </span>
                      <span v-else>
                      {{ totalMProductFiber | currency }}
                      </span>
                  </h3>
                  </div>
                  <!--end card-body-->
              </div>
            <!--end card-->
          </div>
          <div class="col-md-3">
              <div class="card report-card">
                  <div class="card-body">
                  <div class="float-right">
                      <i class="dripicons-user-group report-main-icon"></i>
                  </div>
                  <h5><span class="badge badge-success">Total Produksi Pintu</span></h5>
                  <h3 class="my-3">
                      <span v-if="loadingSales === false">
                      <div class="loadingio-spinner-bars-km984sg9h2">
                          <div class="ldio-m41ff6uvz8">
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                          </div>
                      </div>
                      </span>
                      <span v-else>
                      {{ totalMProductPintu | currency }}
                      </span>
                  </h3>
                  </div>
                  <!--end card-body-->
              </div>
            <!--end card-->
          </div>
          <div class="col-md-3">
              <div class="card report-card">
                  <div class="card-body">
                  <div class="float-right">
                      <i class="dripicons-user-group report-main-icon"></i>
                  </div>
                  <h5><span class="badge badge-success">Total Produksi Pintu Setengah Jadi</span></h5>
                  <h3 class="my-3">
                      <span v-if="loadingSales === false">
                      <div class="loadingio-spinner-bars-km984sg9h2">
                          <div class="ldio-m41ff6uvz8">
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                          </div>
                      </div>
                      </span>
                      <span v-else>
                      {{ totalMProductSetengahJadi | currency }}
                      </span>
                  </h3>
                  </div>
                  <!--end card-body-->
              </div>
            <!--end card-->
          </div>
          <div class="col-md-3">
            <div class="card report-card">
                <div class="card-body">
                <div class="float-right">
                    <i class="dripicons-user-group report-main-icon"></i>
                </div>
                <h5><span class="badge badge-info">Total Product</span></h5>
                <h3 class="my-3">
                    <span v-if="loadingSales === false">
                    <div class="loadingio-spinner-bars-km984sg9h2">
                        <div class="ldio-m41ff6uvz8">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        </div>
                    </div>
                    </span>
                    <span v-else>
                    {{ totalMProduct | currency }}
                    </span>
                </h3>
                </div>
                <!--end card-body-->
            </div>
            <!--end card-->
          </div>
        </div>
        <div class="row">
          <div class="col-md-3">
              <div class="card report-card">
                  <div class="card-body">
                  <div class="float-right">
                      <i class="dripicons-user-group report-main-icon"></i>
                  </div>
                  <h5><span class="badge badge-success">Total Material Fiber</span></h5>
                  <h3 class="my-3">
                      <span v-if="loadingSales === false">
                      <div class="loadingio-spinner-bars-km984sg9h2">
                          <div class="ldio-m41ff6uvz8">
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                          </div>
                      </div>
                      </span>
                      <span v-else>
                      {{ totalMaterialFiber | currency }}
                      </span>
                  </h3>
                  </div>
                  <!--end card-body-->
              </div>
            <!--end card-->
          </div>
          <div class="col-md-3">
              <div class="card report-card">
                  <div class="card-body">
                  <div class="float-right">
                      <i class="dripicons-user-group report-main-icon"></i>
                  </div>
                  <h5><span class="badge badge-success">Total Material Pintu</span></h5>
                  <h3 class="my-3">
                      <span v-if="loadingSales === false">
                      <div class="loadingio-spinner-bars-km984sg9h2">
                          <div class="ldio-m41ff6uvz8">
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                          </div>
                      </div>
                      </span>
                      <span v-else>
                      {{ totalMaterialPintu | currency }}
                      </span>
                  </h3>
                  </div>
                  <!--end card-body-->
              </div>
            <!--end card-->
          </div>
          <div class="col-md-3">
              <div class="card report-card">
                  <div class="card-body">
                  <div class="float-right">
                      <i class="dripicons-user-group report-main-icon"></i>
                  </div>
                  <h5><span class="badge badge-success">Total Material Pintu Setengah Jadi</span></h5>
                  <h3 class="my-3">
                      <span v-if="loadingSales === false">
                      <div class="loadingio-spinner-bars-km984sg9h2">
                          <div class="ldio-m41ff6uvz8">
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                          </div>
                      </div>
                      </span>
                      <span v-else>
                      {{ totalMaterialSetengahJadi | currency }}
                      </span>
                  </h3>
                  </div>
                  <!--end card-body-->
              </div>
            <!--end card-->
          </div>
          <div class="col-md-3">
            <div class="card report-card">
                <div class="card-body">
                <div class="float-right">
                    <i class="dripicons-user-group report-main-icon"></i>
                </div>
                <h5><span class="badge badge-info">Total Material</span></h5>
                <h3 class="my-3">
                    <span v-if="loadingSales === false">
                    <div class="loadingio-spinner-bars-km984sg9h2">
                        <div class="ldio-m41ff6uvz8">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        </div>
                    </div>
                    </span>
                    <span v-else>
                    {{ totalMaterial | currency }}
                    </span>
                </h3>
                </div>
                <!--end card-body-->
            </div>
          <!--end card-->
          </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="top-list-small-toolbar">
                    <div>
                        <h4 class="text-primary">Manufacture Summary</h4>
                        <div class="form-inline">
                            <div class="button-group">
                                <span><b>Company:</b> </span>
                                <select v-model="company_no" class="btn btn-sm btn-soft-outline-primary">
                                  <option value="">-- All --</option>
                                  <option v-for="c in companyList" :key="c.id" :value="c.company_no">{{ c.name }}</option>
                                </select>
                            </div>
                            <div class="button-group ml-2">
                              <span class="mr-1"><b>Type</b></span>
                              <select v-model="type" class="form-control">
                                <option value="">-- All --</option>
                                <option value="Produksi Fiber">Produksi Fiber</option>
                                <option value="Produksi Pintu">Produksi Pintu</option>
                              </select>
                            </div>
                            <div class="button-group ml-2">
                                <span class="mr-1"><b>Date:</b> </span>
                                <date-picker v-model="startDate" type="date" range placeholder="Select date range" @change="refreshList"></date-picker>
                            </div>
                            <button type="button" class="btn btn-sm  btn-hard-primary waves-light waves-effect" @click="refreshList">
                              <i class="fa fa-refresh" aria-hidden="true"></i> Refresh
                            </button>
                            <button class="btn btn-warning btn-sm pull-left dropdown-toggle" type="button" id="printsales" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                              <i class="fa fa-print" aria-hidden="true"></i> Print
                            </button>
                            <div class="dropdown-menu" aria-labelledby="printsales">
                              <a class="dropdown-item" href="javascript:void(0)" @click="print('pdf')">PDF</a>
                              <a class="dropdown-item" href="javascript:void(0)" @click="print('excel')">Excel</a>
                            </div>
                            <input type="search" placeholder="search..." class="form-control mr-1 input-search" v-model="searchQuery" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                      <div class="row">
                        <div class="col-md-6">
                          <div v-for="d in dataRaw" :key="d.id">
                              <h5 class="mt-5 text-center"><b>.:{{ d.name}}:.</b></h5>
                              <div class="table-responsive">
                                  <h5 class="text-center">Material</h5>
                                  <table class="table table-item mb-0 table-sm table-striped table-hover">
                                      <thead>
                                          <th>Category</th>
                                          <th>Product</th>
                                          <th class="text-right">Qty Order</th>
                                          <th class="text-right">Qty Additional</th>
                                          <th class="text-right">Qty Non Biaya</th>
                                          <th class="text-right">Qty</th>
                                          <th>Uom</th>
                                          <th class="text-right">COGS</th>
                                          <th class="text-right">Total</th>
                                      </thead>
                                      <tbody>
                                          <tr v-for="p in d.manufacture_material" :key="p.id">
                                              <td>
                                                  <span class="badge badge-success" v-if="p.category === 'material'">{{ p.category }}</span>
                                                  <span class="badge badge-primary" v-else>{{ p.category }}</span>
                                              </td>
                                              <td><b>[{{ p.product_no}}]</b> {{ p.product }}</td>
                                              <td class="text-right">{{ p.qty_order | currency }}</td>
                                              <td class="text-right">{{ p.qty_additional | currency }}</td>
                                              <td class="text-right">{{ p.qty_noncost | currency }}</td>
                                              <td class="text-right">{{ p.qty | currency }}</td>
                                              <td>{{ p.uom_id }}</td>
                                              <td class="text-right">{{ p.price | currency }}</td>
                                              <td class="text-right">{{ p.total_cogs | currency }}</td>
                                          </tr>
                                      </tbody>
                                      <tfoot>
                                          <tr>
                                              <td></td>
                                              <td></td>
                                              <td></td>
                                              <td></td>
                                              <td></td>
                                              <td class="text-right"><b>{{ d.material_qty | currency }}</b></td>
                                              <td></td>
                                              <td></td>
                                              <td class="text-right"><b>{{ d.material_total | currency }}</b></td>
                                          </tr>
                                      </tfoot>
                                  </table>
                              </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div v-for="d in dataRaw" :key="d.id">
                              <h5 class="mt-5 text-center"><b>.:{{ d.name}}:.</b></h5>
                              <div class="table-responsive">
                                  <h5 class="text-center">Barang Jadi</h5>
                                  <table class="table table-item mb-0 table-sm table-striped table-hover">
                                      <thead>
                                          <th>Product</th>
                                          <th class="text-right">Qty</th>
                                          <th>Uom</th>
                                          <th class="text-right">Price</th>
                                          <th class="text-right">Total</th>
                                      </thead>
                                      <tbody>
                                          <tr v-for="p in d.manufacture_product" :key="p.id">
                                              <td><b>[{{ p.product_no}}]</b> {{ p.product }}</td>
                                              <td class="text-right">{{ p.qty_estimated | currency }}</td>
                                              <td>{{ p.uom_id }}</td>
                                              <td class="text-right">{{ p.price | currency }}</td>
                                              <td class="text-right">{{ p.total | currency }}</td>
                                          </tr>
                                      </tbody>
                                      <tfoot>
                                          <tr>
                                              <td></td>
                                              <td class="text-right"><b>{{ d.mproduct_qty | currency }}</b></td>
                                              <td></td>
                                              <td></td>
                                              <td class="text-right"><b>{{ d.mproduct_total | currency }}</b></td>
                                          </tr>
                                      </tfoot>
                                  </table>
                              </div>
                          </div>
                        </div>
                      </div>
                      <hr>
                      <div class="row mt-5" v-if="convert.length > 0">
                        <div class="col-md-12">
                          <div class="table-responsive">
                            <h5 class="mt-5 text-center"><b>.:Convert (Potongan):.</b></h5>
                            <table class="table table-item mb-0 table-sm table-striped table-hover">
                              <thead>
                                <th>Convert No.</th>
                                <th>Date</th>
                                <th>Product</th>
                                <th class="text-center">Qty</th>
                                <th class="text-center">Uom</th>
                                <th class="text-right">Price</th>
                                <th class="text-right">Total</th>
                                <th>Company</th>
                              </thead>
                              <tbody>
                                <tr v-for="i in convert" :key="i.id">
                                  <td>
                                    <span v-if="i.level === 1">{{ i.convert_no }}</span>
                                    <span v-else class="ml-5"></span>
                                  </td>
                                  <td>{{ i.convert_date | dateFormat('DD/MM/YYYY') }}</td>
                                  <td><b>[{{ i.product_no }}]</b> {{ i.product }}</td>
                                  <td class="text-center">{{ i.qty }}</td>
                                  <td class="text-center">{{ i.uom_id }}</td>
                                  <td class="text-right">{{ i.cost | currency }}</td>
                                  <td class="text-right">
                                    <span v-if="i.level === 1"><b>{{ i.total | currency }}</b></span>
                                    <span v-else>{{ i.total | currency }}</span>
                                  </td>
                                  <td>{{ i.company }}</td>
                                </tr>
                              </tbody>
                              <tfoot>
                                <tr>
                                  <td colspan="3"></td>
                                  <td class="text-center"><b>{{ totalConvertQty | currency }}</b></td>
                                  <td></td>
                                  <td></td>
                                  <td class="text-right"><b>{{ totalConvert | currency }}</b></td>
                                  <td></td>
                                </tr>
                              </tfoot>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <pre>{{ dataRaw }}</pre> -->
    </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import DatePicker from 'vue2-datepicker'
import { convertUrl, manufactureUrl, manufacture2Url, getHeader } from '../config'

export default {
  name: 'ManufactureReportSummary',
  props: ['scroll'],
  components: {
    Loading,
    DatePicker
  },
  data () {
    var date = new Date()
    var firstDay = new Date(date.getFullYear(), date.getMonth(), 1)
    var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0)
    const date1 = new Date(firstDay.getFullYear(), firstDay.getMonth(), firstDay.getDate())
    const date2 = new Date(lastDay.getFullYear(), lastDay.getMonth(), lastDay.getDate())
    return {
      convert: [],
      loadingSales: true,
      type: '',
      uom: null,
      company_no: '',
      product_no: null,
      filterCompany: [],
      startDate: [date1, date2],
      dateNow: new Date(),
      date: new Date().toISOString(),
      company: null,
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#007bff',
        canCancel: true,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      },
      dataRaw: [],
      data: {},
      searchQuery: '',
      ascending: true,
      sortClick: false,
      sortColumn: 'saldo',
      pageSize: 100,
      currentPage: 1,
      title: [{
        name: 'Product',
        prop: 'product_no',
        align: 'text-left'
      }, {
        name: 'Qty',
        prop: 'costs',
        align: 'text-left'
      }, {
        name: 'Purchasing Order',
        prop: 'purchasing_orders',
        align: 'text-left'
      }, {
        name: 'Qty',
        prop: 'purchasing_order_qty',
        align: 'text-left'
      }, {
        name: 'Sales Order',
        prop: 'sale_orders',
        align: 'text-left'
      }, {
        name: 'Qty',
        prop: 'sale_order_qty',
        align: 'text-left'
      }, {
        name: 'Saldo',
        prop: 'saldo',
        align: 'text-left'
      }],
      selectAll: false,
      selected: []
    }
  },
  mounted () {
    this.company_no = ''
    this.date = new Date().toISOString()
    this.$store.dispatch('getCompanyList')
    this.$store.dispatch('getManufactureTypeList')
  },
  computed: {
    ...mapState({
      rowsTable: state => state.data.rowsTable,
      companyList: state => state.companies.companyList,
      manufactureTypeList: state => state.manufactures.manufactureTypeList
    }),
    totalConvert () {
      var sum = 0
      var array = this.convert
      for (let i = 0; i < array.length; i++) {
        if (array[i].level === 1) {
          sum += parseFloat(array[i].total)
        }
      }
      return sum
    },
    totalConvertQty () {
      var sum = 0
      var array = this.convert
      for (let i = 0; i < array.length; i++) {
        if (array[i].level === 1) {
          sum += parseFloat(array[i].qty)
        }
      }
      return sum
    },
    totalMaterialPintu () {
      var array = this.dataRaw.filter(d => d.name === 'Produksi Pintu')
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].material_total)
      }
      return sum
    },
    totalMaterialFiber () {
      var array = this.dataRaw.filter(d => d.name === 'Produksi Fiber')
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].material_total)
      }
      return sum
    },
    totalMaterialSetengahJadi () {
      var array = this.dataRaw.filter(d => d.name === 'Produksi Pintu Setengah Jadi')
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].material_total)
      }
      return sum
    },
    totalMaterial () {
      var array = this.dataRaw
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].material_total)
      }
      return sum
    },
    totalMProductPintu () {
      var array = this.dataRaw.filter(d => d.name === 'Produksi Pintu')
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].mproduct_total)
      }
      return sum
    },
    totalMProductFiber () {
      var array = this.dataRaw.filter(d => d.name === 'Produksi Fiber')
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].mproduct_total)
      }
      return sum
    },
    totalMProductSetengahJadi () {
      var array = this.dataRaw.filter(d => d.name === 'Produksi Pintu Setengah Jadi')
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].mproduct_total)
      }
      return sum
    },
    totalMProduct () {
      var array = this.dataRaw
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].mproduct_total)
      }
      return sum
    },
    companyData () {
      var obj = {
        name: null,
        address: null,
        phone: null
      }
      const cmp = this.companyList.find(d => d.company_no === this.company_no)
      if (cmp) {
        obj = {
          name: cmp.name,
          address: cmp.address,
          phone: cmp.phone
        }
      }
      return obj
    },
    pageLength: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      var length = count / this.pageSize

      return Math.ceil(length)
    },
    rowsTotal: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      // console.log(count)
      return count
    },
    filterData: function () {
      if (this.searchQuery.length > 0) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      }
      var col = this.sortColumn
      var ascending = this.ascending
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.dataRaw.sort(function (a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0
      }).filter(d => {
        for (const name in d) {
          if (d[name] !== null) {
            if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
              return d
            }
          }
        }
      }).filter((row, index) => {
        const start = (this.currentPage - 1) * this.pageSize
        const end = this.currentPage * this.pageSize
        if (index >= start && index < end) return true
      })
    }
  },
  methods: {
    async print (type) {
      this.$Progress.start()
      this.loader.isLoading = true
      var data = {
        format: type,
        data: this.dataRaw
      }
      if (data.length === 0) {
        this.$swal('Error', 'Data masih kosong', 'error')
        return false
      }
      await axios.post(manufacture2Url + '/summary', data, { responseType: 'blob' })
        .then(response => {
          const objectUrl = URL.createObjectURL(response.data)
          console.log('Showing PDF...')
          window.open(objectUrl, '_blank')
          this.$Progress.finish()
          this.loader.isLoading = false
        })
        .catch(error => {
          this.$Progress.finish()
          this.loader.isLoading = false
          console.log(error)
          console.log(error.response)
        })
    },
    setPageSizeOnChange: function () {
      this.currentPage = 1
    },
    sortTable: function sortTable (col) {
      this.currentPage = 1
      if (this.sortColumn === col) {
        this.ascending = !this.ascending
      } else {
        this.ascending = true
        this.sortColumn = col
      }
    },
    nextPage: function () {
      if ((this.currentPage * this.pageSize) < this.rowsTotal) this.currentPage++
    },
    prevPage: function () {
      if (this.currentPage > 1) this.currentPage--
    },
    select () {
      this.selected = []
      //   this.currentPage = 1
      if (!this.selectAll) {
        for (const i in this.filterData) {
          this.selected.push(this.filterData[i].id)
        }
      }
    },
    async refreshList () {
      this.$Progress.start()
      this.loader.isLoading = true
      const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      var obj = {
        begin: begin,
        end: end,
        company_no: this.company_no,
        type: this.type
      }
      console.log(obj)
      var productJadi = []
      await axios.post(manufactureUrl + '/report-summary', obj, { headers: getHeader() })
        .then(response => {
          this.dataRaw = response.data.data
          for (let i = 0; i < this.dataRaw.length; i++) {
            var data = this.dataRaw[i].manufacture_product
            for (let b = 0; b < data.length; b++) {
              productJadi.push(data[b].product_no)
            }
          }
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
      var body = {
        begin: begin,
        end: end,
        company_no: this.company_no,
        product: productJadi
      }
      console.log(body)
      console.log(convertUrl + '/get-by-product')
      await axios.post(convertUrl + '/get-by-product', body, { headers: getHeader() })
        .then(response => {
          console.log(response.data.message)
          this.convert = response.data.data
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
        })
      await this.$Progress.finish()
      this.loader.isLoading = false
    }
  }
}
</script>
